export default __webpack_public_path__ + "adb87c52c69a46d20e1cb19105ab3fe3.svg";